/**
 * Mobile hamburger drawer.
 * Idempotent: safe to call once only (guards against double-bind).
 */
let bound = false;

export function initMobileNav() {
  if (bound) return;
  const toggle = document.getElementById("navToggle");
  const drawer = document.getElementById("mobileNav");
  if (!toggle || !drawer) return;
  bound = true;

  const setOpen = (open) => {
    document.body.classList.toggle("nav-open", open);
    toggle.setAttribute("aria-expanded", String(open));
    toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
  };

  toggle.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(!document.body.classList.contains("nav-open"));
  });

  drawer.addEventListener("click", (e) => {
    if (e.target.closest("[data-nav]")) {
      setOpen(false);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setOpen(false);
  });

  // Close if user resizes up to desktop nav
  window.addEventListener("resize", () => {
    if (window.innerWidth > 1180) setOpen(false);
  });
}
